import { Alert, Box, Chip, Typography } from '@mui/material';
import { useFlag } from '../lib/flags';

export function DashboardPage() {
  // Feature flag: create a flag named 'new-dashboard' in Unleash to enable
  // the new dashboard experience for specific users or rollout percentages.
  const newDashboard = useFlag('new-dashboard');

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        gap: 2,
      }}
    >
      <Typography variant="h4">Dashboard</Typography>

      {newDashboard ? (
        <Alert severity="info" icon={false}>
          <Chip label="new-dashboard flag: ON" color="primary" size="small" sx={{ mr: 1 }} />
          You are seeing the new dashboard experience.
        </Alert>
      ) : (
        <Typography variant="body2" color="text.secondary">
          Enable the <code>new-dashboard</code> feature flag in Unleash to unlock the new
          experience.
        </Typography>
      )}
    </Box>
  );
}
